module.exports = __webpack_public_path__ + "static/btg-logo-1-f729a8bdce081801cb0d027a4a0a5191.png";